import { motion } from "framer-motion";
import { Navigate, useParams } from "react-router-dom";
import { legalPages } from "@/components/equinox/data";

export default function LegalPage() {
  const { slug } = useParams();
  const page = legalPages[slug];

  if (!page) {
    return <Navigate to="/" replace />;
  }

  return (
    <section className="px-6 pb-16 pt-14 sm:px-8 lg:px-12">
      <div className="mx-auto max-w-5xl">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          <p className="text-xs uppercase tracking-[0.3em] text-white/[0.42]">Legal</p>
          <h1 className="mt-4 font-display text-4xl text-white sm:text-5xl">{page.title}</h1>
          <p className="mt-5 max-w-3xl text-base leading-8 text-white/[0.64]">{page.intro}</p>
        </motion.div>

        <div className="mt-10 space-y-5">
          {page.sections.map((section, index) => (
            <motion.article
              key={section.heading}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              className="glitter-card glass-panel cinematic-card rounded-[1.8rem] p-6"
              data-testid={`legal-section-${index + 1}`}
            >
              <h2 className="font-display text-2xl text-white">{section.heading}</h2>
              <p className="mt-4 text-sm leading-7 text-white/[0.68]">{section.body}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}